import React, { useEffect, useRef } from "react";

import {
  Button,
  Modal,
  Layout,
  Text,
  Padding,
  Tab,
} from "@kidslivesafe/sc-react";
import {
  selectMemberExperienceData,
  setMemberExperienceDataAsync,
} from "../../features/authentication/authenticationSlice";

import {
  selectVehicleReportHistory,
  setVehicleNoResultsModalShown,
  selectVehicleNoResultsModalShown,
  selectReportHistoryStatus,
} from "../../features/reports/reportsSlice";
import { useAppSelector, useAppDispatch } from "../../hooks/hooks";
import { selectAdminStatus } from "../../features/admin/adminSlice";
import { selectPrimarySubscription } from "../../features/subscriptions/subscriptionSlice";
import { selectAccountType } from "../../features/authentication/authenticationSlice";

import { sendMemberEventAsync } from "../../features/admin/adminSlice";

import {
  setTab,
  toggleOpen,
} from "../../features/multisearch/multisearchSlice";

const VehicleNoResultsModal: React.FC = () => {
  const [show, setShow] = React.useState(true);
  const dispatch = useAppDispatch();
  const vehicleNoResultsModalShown = useAppSelector(
    selectVehicleNoResultsModalShown,
  );
  const [showVehicleNoResultsModal, setShowVehicleNoResultsModal] =
    React.useState(false);
  const memberExperienceData = useAppSelector(selectMemberExperienceData);
  const adminStatus = useAppSelector(selectAdminStatus);
  const loading = adminStatus === "loading";

  const reportHistoryStatus = useAppSelector(selectReportHistoryStatus);
  const reportHistoryLoading = reportHistoryStatus === "loading";

  const vehicleReportHistory = useAppSelector(selectVehicleReportHistory);
  const vehicleReportHistoryIsEmpty =
    !vehicleReportHistory || vehicleReportHistory.length === 0;
  const subscriptionInfo = useAppSelector(selectPrimarySubscription);
  const accountType = useAppSelector(selectAccountType);

  useEffect(() => {
    let showVehicleModalFromReportHistory = false;
    let showVehicleModalFromMemberExperience = true;
    if (
      vehicleReportHistoryIsEmpty &&
      (accountType === "vehicle" || accountType === "aamva")
    ) {
      showVehicleModalFromReportHistory = true;
    }

    if (
      memberExperienceData &&
      memberExperienceData["shownVehicleNoResultsModal"] === "true"
    ) {
      showVehicleModalFromMemberExperience = false;
    }
    setShowVehicleNoResultsModal(
      showVehicleModalFromReportHistory &&
        showVehicleModalFromMemberExperience &&
        !vehicleNoResultsModalShown,
    );
  }, [
    vehicleReportHistoryIsEmpty,
    memberExperienceData,
    vehicleNoResultsModalShown,
    subscriptionInfo,
  ]);

  const handleMultiSearchOpen = (tab: Tab) => {
    dispatch(setTab(tab));
    dispatch(toggleOpen());
  };

  useEffect(() => {
    if (showVehicleNoResultsModal) {
      dispatch(
        sendMemberEventAsync({
          EventCategory: "Modal Display",
          EventAction: "No Match Found Modal Display",

          MetaData: JSON.stringify({
            key: "No VIN Found Modal",
            value: `Display`,
          }),
        }),
      );
    }
  }, [dispatch, showVehicleNoResultsModal]);

  if (!showVehicleNoResultsModal || reportHistoryLoading) {
    return null;
  } else {
    return (
      <Modal
        open={show}
        setOpen={() => {
          setShow(false);
          dispatch(
            sendMemberEventAsync({
              EventCategory: "Button Click",
              EventAction: "Exit Modal",

              MetaData: JSON.stringify({
                key: "No VIN Found Modal",
                value: `Close Modal`,
              }),
            }),
          );
          dispatch(setVehicleNoResultsModalShown());
          dispatch(
            setMemberExperienceDataAsync({
              key: "shownVehicleNoResultsModal",
              value: true,
            }),
          );
        }}
        size="fit-content"
        scrollable={false}
        useShowModal={true}
        xClose
      >
        <Layout
          type="flex"
          flexProps={{
            direction: "column",
            gap: "sm",
            alignItems: "center",
          }}
        >
          <Layout
            type="flex"
            flexProps={{
              direction: "column",
              gap: "sm",
            }}
          >
            <div>
              <Text textAlign="center" tag="h2" fontWeight="semibold">
                No Match Found
              </Text>
              <Padding top="md">
                <Text textAlign="center" size="sm">
                  We don't have a report for that vehicle.
                </Text>
                <Padding top="xxs">
                  <Text textAlign="center" size="sm">
                    Please double-check your entry or search for a different
                    vehicle.
                  </Text>
                </Padding>
              </Padding>
            </div>
          </Layout>
          <Layout
            type="flex"
            flexProps={{
              direction: "column",
              gap: "sm",
              alignItems: "center",
            }}
          >
            <Padding space="sm">
              <Layout
                type="flex"
                flexProps={{
                  direction: "column",
                  gap: "sm",
                  alignItems: "center",
                }}
              >
                <Button
                  buttonText="Try Again"
                  handleClick={() => {
                    setShow(false);
                    dispatch(
                      sendMemberEventAsync({
                        EventCategory: "Button Click",
                        EventAction: "Try search again",

                        MetaData: JSON.stringify({
                          key: "No VIN Found Modal",
                          value: `Retry Search`,
                        }),
                      }),
                    );
                    dispatch(setVehicleNoResultsModalShown());
                    dispatch(
                      setMemberExperienceDataAsync({
                        key: "shownVehicleNoResultsModal",
                        value: true,
                      }),
                    );
                    handleMultiSearchOpen("vehicle");
                  }}
                  clicked={loading}
                  loading={loading}
                />
              </Layout>
            </Padding>
          </Layout>
        </Layout>
      </Modal>
    );
  }
};

export default VehicleNoResultsModal;
